module.exports = __webpack_public_path__ + "static/media/sin_agendados.5e110a09.svg";